import React, {Component} from 'react'
import {withStyles} from '@material-ui/core/styles/index'
import {withRouter} from 'react-router-dom'
import {
  Button,
  Card,
  CardContent,
  RadioGroup,
  Radio,
  FormControlLabel,
  Typography,
  Divider,
} from '@material-ui/core'
import classNames from 'classnames'
import {FuseAnimate} from '@fuse'
import {Query} from 'react-apollo'

import {USER} from '../../../graphql/query'
import {requireAuth} from '../../../auth'
import {logout} from '../../../utils'

const styles = theme => ({
  root: {
    background:
      "url('/assets/images/backgrounds/dark-material-bg.jpg') no-repeat",
    backgroundSize: 'cover',
  },
  card: {
    width: '100%',
    maxWidth: 384,
  },
})

class ProjectsPage extends Component {
  state = {
    selectedValue: '0',
  }

  handleRadioChange = e => {
    this.setState({
      selectedValue: e.target.value.toString(),
    })
  }

  onSelectButtonEnable = () => {
    return !this.props.projects[this.state.selectedValue]
  }

  onSelectProject = () => {
    // const selectedProject = this.props.projects[this.state.selectedValue]
    this.props.history.push(`/project/${this.state.selectedValue}/settings`)
  }

  onNewProject = () => {
    this.props.history.push('/project/new')
  }

  onLogout = async () => {
    try {
      logout()
    } catch (e) {
      console.log(e)
    }
  }

  render() {
    const {classes} = this.props
    return (
      <div
        className={classNames(
          classes.root,
          'flex flex-col flex-auto flex-no-shrink items-center justify-center p-32',
        )}
      >
        <div className="flex flex-col items-center justify-center w-full">
          <FuseAnimate animation="transition.expandIn">
            <Card className={classes.card}>
              <CardContent className="flex flex-col items-center justify-center p-32">
                <Typography variant="title" className="mt-16 mb-32">
                  Select project
                </Typography>
                <div>
                  <Query query={USER}>
                    {({loading, error, data}) => {
                      if (loading) {
                        return null
                      }

                      const {permissions} = data.me
                      return permissions.length ? (
                        <div>
                          <RadioGroup
                            aria-label="Project"
                            name="project"
                            value={this.state.selectedValue}
                            onChange={e => {
                              this.setState({
                                selectedValue: e.target.value.toString(),
                              })
                            }}
                          >
                            {permissions.map(permission => (
                              <FormControlLabel
                                key={permission.id}
                                value={permission.projectId}
                                control={<Radio style={{color: '#BCA1F5'}} />}
                                label={permission.projectName}
                              />
                            ))}
                          </RadioGroup>

                          <Button
                            variant="raised"
                            disabled={
                              !permissions.find(
                                p => p.projectId === this.state.selectedValue,
                              )
                            }
                            // color="primary"
                            style={{background: '#663EE8', color: 'white'}}
                            className="w-224 mt-16"
                            aria-label="Select project"
                            onClick={this.onSelectProject}
                          >
                            Select
                          </Button>
                        </div>
                      ) : (
                        <Button
                          variant="raised"
                          color="primary"
                          className="w-224"
                          aria-label="New project"
                          onClick={this.onNewProject}
                        >
                          New project
                        </Button>
                      )
                    }}
                  </Query>
                </div>
                <div>
                  <div className="my-24 flex items-center justify-center">
                    <Divider className="w-full" />
                  </div>
                  <Button
                    // color="primary"
                    style={{color: '#663EE8'}}
                    className="w-224"
                    aria-label="Logout"
                    onClick={this.onLogout}
                  >
                    Logout
                  </Button>
                </div>
              </CardContent>
            </Card>
          </FuseAnimate>
        </div>
      </div>
    )
  }
}

export default withStyles(styles, {withTheme: true})(
  withRouter(requireAuth(ProjectsPage)),
)



// WEBPACK FOOTER //
// ./src/main/content/projects/ProjectsPage.js